module.exports = __webpack_public_path__ + "static/media/ios_tips_01.a05a2425.png";